import React from "react";
export const ErrorMessage = ({ parentAttributeName, attributeName, error }) => {
    return (
        <div className="flex-column m-t-12">
            {parentAttributeName && (
                <div className="flex">
                    <div className="txt-bold m-r-4">Item:</div>
                    <div>{parentAttributeName}</div>
                </div>
            )}
            <div className="flex">
                {attributeName && <div className="txt-bold m-r-4">{attributeName}:</div>}
                <div>{error}</div>
            </div>
        </div>
    );
};
